import React, { useContext } from 'react';
import * as Styled from './styled';
import {
    ThemeContext,
    ThemeDispatchContext,
} from '@src/index';

const ThemeSwitch = () => {
    const { isDarkMode } = useContext(ThemeContext);
    const setDarkMode = useContext(ThemeDispatchContext);

    return (
        <Styled.ThemeSwitchWrapper>
            <Styled.ThemeSwitchInput
                type="checkbox"
                checked={isDarkMode}
                onChange={() => setDarkMode(!isDarkMode)}
            />
            <Styled.ThemeSwitchSlider
                isDarkMode={isDarkMode}
            />
        </Styled.ThemeSwitchWrapper>
    );
};

export default ThemeSwitch;
